const NoListItems = ({ text, customHeight }) => {
  return (
    <div
      className="no-list-items"
      style={{
        maxHeight: customHeight,
      }}
    >
      {text}
    </div>
  );
};

export default NoListItems;
